import request from "@/utils/request";

// 数据字典内存缓存，刷新页面自动清空
const dictCache = new Map();
// 合并并发请求：同一字典类型同时调用时共享同一个 Promise
const pendingRequests = new Map();

/**
 * 获取数据字典（带内存缓存，刷新页面清空）
 * @param {string} type - 字典名
 * @returns {Promise}
 */
export function getDictData(type) {
  // 缓存命中，直接返回
  if (dictCache.has(type)) {
    return Promise.resolve(dictCache.get(type));
  }
  // 已有正在进行的请求，复用该 Promise
  if (pendingRequests.has(type)) {
    return pendingRequests.get(type);
  }
  const promise = request({
    url: `/system/dict/data/type/${type}`,
    method: "get",
  }).then((res) => {
    dictCache.set(type, res);
    pendingRequests.delete(type);
    return res;
  });
  pendingRequests.set(type, promise);
  return promise;
}

/**
 * 清除指定字典缓存（不传 type 则清除全部）
 * @param {string} [type] - 字典名，可选
 */
export function clearDictCache(type) {
  if (type) {
    dictCache.delete(type);
  } else {
    dictCache.clear();
  }
}
